import AuthBlock from "./components/AuthBlock";

function App() {
  return <div>hello</div>;
}

export default App;
